import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const checkRoleName = (name) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ROLES_AND_PERMISSION.CHECK_ROLE_NAME(name)
  );
};

export default checkRoleName;
